import { FC } from "react";
import { Box } from "@mui/material";
import { gameState } from "@/services/gameState";
import GameOverviewTable from "../challenge-detail-page/footer/GameOverviewTable";

const RefereeTabletSetStats: FC = () => {
  const scoreConfig = gameState("scoreConfiguration");
  return (
    <Box px={"0vw"} fontSize={"2.5vw"}>
      <GameOverviewTable
        showCurrentSetOnly={false}
        showChallenges={scoreConfig.videoChallengeAvailable}
        showPoints={true}
      />
    </Box>
  );
};

export default RefereeTabletSetStats;
